import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from "react-router-dom";
import "./baseStyles.css";
import { jwtDecode } from "jwt-decode";
import { canUsePilotFeatures } from "../featureAccess";

const RotatingTagline = () => {
  const taglines = [
    "Simple reminders. Reinforce what matters.",
    "Simple reminders. Build better habits.",
    "Simple reminders. Practice personal growth.",
    "Simple reminders. Train your thinking.",
    "Simple reminders. Make learning stick.",
    "Simple reminders. Practice personal growth.",
    "Simple reminders. Grow through repetition.",
  ];
  const [currentIndex, setCurrentIndex] = useState(0);
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % taglines.length);
    }, 60000);
    return () => clearInterval(interval);
  }, []);
  return <div className="brand-tagline">{taglines[currentIndex]}</div>;
};

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);
  const closeMenu = () => setIsMenuOpen(false);
  const [showMaintain, setShowMaintain] = useState(false);
  const isDev = process.env.NODE_ENV !== "production";

  const navigate = useNavigate();
  const isAuthed = !!localStorage.getItem("idToken");

  let cognitoUserId = "";
  try {
    const idToken = localStorage.getItem("idToken");
    if (idToken) {
      const decoded = jwtDecode(idToken);
      cognitoUserId = decoded?.sub || "";
    }
  } catch (e) {
    console.error("Could not decode idToken", e);
  }

  const handleLogout = (e) => {
    e.preventDefault();
    localStorage.clear();
    closeMenu();
    setShowMaintain(false);
    navigate("/login", { replace: true });
  };



  return (
    <nav className="navbar">
      <div className="navbar-header">
        <button className="hamburger" onClick={toggleMenu}>☰</button>

        <div className="brand-wrapper">
          <table className="brand-table">
            <tbody>
              <tr>
                <td className="brand-check-cell">✓</td>
                <td className="brand-name-cell">
                  <div className="brand-name">myDailyReminders</div>
                </td>
              </tr>
              <tr>
                <td></td>
                {/* <td><div className="brand-tagline">Simple reminders. Smarter relationships.</div></td> */}
                <td><RotatingTagline /></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <ul className={`nav-links ${isMenuOpen ? "show" : ""}`}>
        <li><Link to="/list-manager" onClick={closeMenu}>Home</Link></li>
        <li><Link to="/campaign-catalog" onClick={closeMenu}>Catalog</Link></li>
        <li><Link to="/myFavorites" onClick={closeMenu}>myFavorites</Link></li>
        <li><Link to="/big-question" onClick={closeMenu}>the Big Question</Link></li>
        <li><Link to="/locked-page" onClick={closeMenu}>myLocked Page</Link></li>

        <li className={`dropdown ${showMaintain ? 'open' : ''}`}>
          <span className="dropdown-toggle" onClick={() => setShowMaintain(!showMaintain)}>
            Maintain ▾
          </span>
          {showMaintain && (
            <ul className="dropdown-menu">
              <li>
                <Link to="/list-manager" onClick={() => { closeMenu(); setShowMaintain(false); }}>
                  Manage Lists
                </Link>
              </li>
              <li>
                <Link to="/item-manager" onClick={() => { closeMenu(); setShowMaintain(false); }}>
                  Manage Items
                </Link>
              </li>
              <li>
                <Link to="/customer-manager" onClick={() => { closeMenu(); setShowMaintain(false); }}>
                  Manage Profile
                </Link>
              </li>
              <li>
                <Link to="/big-question-history" onClick={() => { closeMenu(); setShowMaintain(false); }}>
                  BigQuestion History
                </Link>
              </li>
              <li>
                <Link to="/favorites-history" onClick={() => { closeMenu(); setShowMaintain(false); }}>
                  Favorites History
                </Link>
              </li>


              <li>
                <Link to="/login" onClick={handleLogout}>Log out</Link>
              </li>




              {canUsePilotFeatures(cognitoUserId) && (
                <li>
                  <Link to="/upload-campaign-data" onClick={() => { closeMenu(); setShowMaintain(false); }}>
                    Upload Campaign Data
                  </Link>
                </li>
              )}
            </ul>
          )}
        </li>


      </ul>
    </nav>
  );
};

export default Navbar;
